export default __webpack_public_path__ + "static/media/triangleDown.f86b0461.svg";